import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM13.3535 9.14648C13.1583 8.95122 12.8417 8.95122 12.6465 9.14648L9 12.793L6.85352 10.6465C6.65825 10.4512 6.34175 10.4512 6.14648 10.6465C5.95122 10.8417 5.95122 11.1583 6.14648 11.3535L9 14.207L13.3535 9.85352C13.5488 9.65825 13.5488 9.34175 13.3535 9.14648ZM14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#6FCF97"
    />
  </svg>
);
